<template>
  <div
    v-if="property"
    class="mt-6"
  >
    <v-description>
      <v-description-item>
        <template #left>
          {{ $t('property').capitalize() }}
        </template>

        <template #right>
          <p class="tag is-info is-light is-rounded">
            {{ property.full_address_with_unity }}
          </p>
        </template>
      </v-description-item>
    </v-description>

    <h2 class="title is-5 mr-5">
      {{ $t("property_for_rent_information").capitalize() }}
    </h2>

    <v-description>
      <v-description-item>
        <template #left>
          {{ $t('application_file_bail') }}
        </template>

        <template #right>
          {{ $dayjs(applicationFile.lease_term_start_date).format('LL') }} {{ $t('application_file_to') }} {{ $dayjs(applicationFile.lease_term_end_date).format('LL') }}
        </template>
      </v-description-item>

      <v-description-item>
        <template #left>
          {{ $t('application_file_rent') }}
        </template>

        <template #right>
          <p>
            {{ applicationFile.rent }}$
          </p>
        </template>
      </v-description-item>
      <v-description-item>
        <template #right>
          <div class="py-3">
            <button
              class="button is-light is-small"
              type="button"
              @click="isShownInclusionModal = true"
            >
              <span class="icon">
                <i class="mdi mdi-check-circle" />
              </span>
              <span>
                {{ $t("inclusions").capitalize() }} ({{
                  applicationFile.property.inclusions_count
                }})
              </span>
            </button>
          </div>
        </template>
      </v-description-item>
    </v-description>
    <d-card>
      <section class="section">
        <div class="container">
          <h2 class="title is-4">
            Dépôt
          </h2>
          <p class="content">
            Envoyer un seul virement Interac de <strong>100$</strong> au courriel suivant : <strong>info@devloc.ca</strong>
          </p>
          <ul class="content">
            <li>Même si vous êtes plusieurs locataires, il ne faut envoyer qu’un seul dépôt.</li>
            <li>Tous les détails et conditions se trouvent dans une autre pièce jointe.</li>
          </ul>

          <h2 class="title is-4">
            Information sur le dépôt
          </h2>
          <p class="content">
            Le dépôt de <strong>100$</strong> doit être effectué au moyen d’un virement Interac à l’adresse suivante : <strong>info@devloc.ca</strong>
          </p>
          <h3 class="title is-5">
            Information pour le virement :
          </h3>
          <ul class="content">
            <li><strong>Question :</strong> Entreprise</li>
            <li><strong>Réponse :</strong> Devloc</li>
            <li><strong>Message/Description :</strong> Numéro civique du logement (ex : 1234)</li>
          </ul>

          <h2 class="title is-4">
            Conditions
          </h2>
          <p class="content">
            L’envoi du dépôt de 100$ officialise la priorisation de votre candidature dans le processus de sélection et d’application. Le dépôt sera déductible de votre premier mois de loyer si et seulement si :
          </p>
          <ol class="content">
            <li>Votre candidature est acceptée.</li>
            <li>Vous signez le bail dans le délai prescrit.</li>
          </ol>

          <p class="content">
            <strong>Le dépôt ne sera pas remboursable</strong> dans les conditions suivantes :
          </p>
          <ol class="content">
            <li>Si un (ou plusieurs) candidat-locataire se désiste pendant l’application ou à signer le bail.</li>
            <li>Si un (ou plusieurs) candidat-locataire prend plus de <strong>48 heures</strong> pour envoyer toutes les informations et documents requis.</li>
            <li>Si un (ou plusieurs) candidat-locataire prend plus de <strong>24 heures</strong> à signer le bail électroniquement.</li>
            <li>Si l’enquête de crédit et/ou le dossier d’un (ou plusieurs) candidat-locataire n’est pas satisfaisant. Dans cette éventualité, nous conserverons <strong>50$</strong> pour chaque enquête de crédit effectuée.</li>
          </ol>

          <p class="content">
            En envoyant le dépôt, vous acceptez les conditions mentionnées ci-haut.
          </p>
          <p class="content">
            <strong>Cordialement,</strong>
          </p>

          <p class="content">
            En transmettant vos documents et informations, vous consentez expressément à leur partage avec les personnes dûment habilitées et responsables de leur traitement et consultation, et ce, dans le respect des lois et règlements applicables en matière de confidentialité et de protection des données personnelles.
          </p>
        </div>
        <div class="mt-6">
          <div>
            <div class="w-isfullwidth mb-4">
              <label class="checkbox">
                <input
                  v-model="acceptedTermsAndConditions"
                  type="checkbox"
                >
                <strong>{{ $t('accept_all_condition_label') }}</strong>
              </label>
            </div>
            <div>
              <button
                class="button is-primary is-fullwidth"
                type="button"
                :disabled="!acceptedTermsAndConditions"
                @click="confirm"
              >
                {{ $t('submit_application') }}
              </button>
            </div>
          </div>
        </div>
      </section>
    </d-card>

    <b-modal
      v-model="isShownInclusionModal"
      :width="600"
      @close="isShownInclusionModal = false"
    >
      <div class="modal-card">
        <header
          class="modal-card-head is-flex-direction-column is-flex is-align-items-flex-start is-size-6 has-text-weight-bold"
        >
          {{ $t("inclusion_list").capitalize() }}
        </header>
        <section class="modal-card-body">
          <v-inclusions
            v-if="applicationFile.property.active_inclusions.length"
            :inclusions="applicationFile.property.active_inclusions"
            class="is-button-block-responsive"
          />
        </section>
        <footer class="modal-card-foot">
          <b-button
            :label="$t('close')"
            @click="isShownInclusionModal = false"
          />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseDescriptionList from "@/shared/components/BaseDescriptionList.vue";
import BaseDescriptionListItem from "@/shared/components/BaseDescriptionListItem.vue";
import ShowInclusionComponent from "@/shared/components/inclusions/ShowInclusionComponent.vue";

export default {
  components: {
    "v-description": BaseDescriptionList,
    "v-description-item": BaseDescriptionListItem,
    "v-inclusions": ShowInclusionComponent,
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      acceptedTermsAndConditions: false,
      isShownInclusionModal: false,
    };
  },
  computed: {
    property() {
      if (!this.data) {
        return null;
      }

      return this.data.application_file.property;
    },
    applicationFile() {
      if (!this.data) {
        return null;
      }

      return this.data.application_file;
    },
    inclusions() {

      if (!this.data.application_file.property) {
        return "-";
      }

      const property = this.data.application_file.property;

      if (!property.active_inclusions || !property.active_inclusions.length) {
        return "-";
      }

      return property.active_inclusions
        .map(inclusion => inclusion.inclusion_label)
        .join(", ");

    }
  },
  methods: {
    confirm() {
      this.$http
        .post(
          this.$laravel.route("public.applicant.accept_general_terms_and_condition", {
            applicant: this.data.applicant.id,
          })
        )
        .then(() => {
          this.$emit("success");
        });
    }
  }
};
</script>
<style scoped>
.content {
  list-style: disc !important;
  list-style-position: inside !important;
}
</style>
